module.exports = __webpack_public_path__ + "static/media/lakshay.85673b2f.jfif";